import React from "react";
import EmptyList from "components/BlogPage/Common/EmptyList";
import CVlayout from "./CVlayout";

const Interncv = (props) => {
  const { blogs } = props;

  return <div>{!blogs.length ? <EmptyList /> : <CVlayout blogs={blogs} />}</div>;
};

export default Interncv;
